import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GetVehicleResult, CreateCustomer, UpdateCustomer } from 'src/app/Api_Module';
import { titles } from 'src/app/models/constants.model';
import { ControlContainer, NgForm } from '@angular/forms';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'crg-customer-details',
  templateUrl: './customer-details.component.html',
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class NewCustomerDetailsComponent implements OnInit {
  @Input() customer: CreateCustomer | UpdateCustomer;
  @Input() updateMode: boolean;

  titles: string[];

  constructor(public authSrvc: AuthenticationService ) { }

  ngOnInit() {
    this.titles = titles;
  }
}
